import React from 'react';

import { useTwoFAAuth } from './hooks/useTwoFAAuth';
import { VerifyCodeCard } from './containers/VerifyCodeCard/VerifyCodeCard';
import { VerificationMethodCard } from './containers/VerificationMethodCard/VerificationMethodCard';

type TwoFAAuthProps = {
  formId: string;
  phoneNumber: string;
  onVerifyCode: (consumer: string, code: string) => Promise<void>;
};

const TwoFAAuth = ({ formId, phoneNumber, onVerifyCode }: TwoFAAuthProps) => {
  const {
    mode,
    consumer,
    nextVerificationCodeCallEpoch,
    setMode,
    email,
    verificationChannel,
    sendVerificationCode,
    changeVerificationMethod,
  } = useTwoFAAuth({
    phoneNumber,
  });

  const handleVerifyCode = async (code: string) => {
    await onVerifyCode(consumer, code);
  };

  if (mode === 'chooseVerificationMethod') {
    return (
      <VerificationMethodCard
        formId={formId}
        defaultValues={{ email, verificationChannel }}
        onChangeVerificationMethod={changeVerificationMethod}
      />
    );
  }

  return (
    <VerifyCodeCard
      formId={formId}
      consumer={consumer}
      nextVerificationCodeCallEpoch={nextVerificationCodeCallEpoch}
      onResendCodeClick={sendVerificationCode}
      onChangeMethodClick={() => setMode('chooseVerificationMethod')}
      verifyCode={handleVerifyCode}
    />
  );
};

export { TwoFAAuth };
